// @flow
import { combineReducers } from "redux";
import { reducer as toastrReducer } from "react-redux-toastr";

import userReducer from "../services/authService/authReducer";
import testReducer from "../components/containers/test1/test1Reducer";
import menuBarReducer from "../components/commons/menuBar/menuBarRedux/menuBarReducer";
import pageReducer from "../services/pageService/pageReducer";
import createTicketReducer from "../components/containers/ticketing/createTicket/createTicketRedux/createTicketReducer";
import ticketDashboardReducer from "../components/containers/ticketing/ticketDashboard/ticketDashboardRedux/ticketDashbaordReducer";
import viewTicketReducer from "../components/containers/ticketing/viewTicket/viewTicketRedux/viewTicketReducer";
import ticketingCcModalReducer from "../components/commons/ticketingCcModal/ticketingCcModalRedux/ticketingCcModalReducer";
import buSettingsReducer from "../components/containers/ticketing/buSettings/buSettingsRedux/buSettingsReducer";
import resolverGroupReducer from "../components/containers/ticketing/resolverGroup/resolverGroupRedux/resolverGroupReducer";
import categorySettingsReducer from "../components/containers/ticketing/categorySettings/categorySettingsRedux/categorySettingsReducer";
import attachmentReducer from "../components/commons/attachments/attachmentsRedux/attachmentReducer";
import ticketingSuggestionModalReducer from "../components/commons/ticketingSuggestionModal/ticketingSuggestionModalRedux/ticketingSuggestionModalReducer";

const rootReducer = combineReducers({
  userProfile: userReducer,
  testState: testReducer,
  menuBarState: menuBarReducer,
  toastr: toastrReducer,
  pageState: pageReducer,
  createTicketState: createTicketReducer,
  ticketDashboardState: ticketDashboardReducer,
  viewTicketState: viewTicketReducer,
  ticketingCcModalState: ticketingCcModalReducer,
  buSettingsState: buSettingsReducer,
  categorySettingsState: categorySettingsReducer,
  resolverGroupState: resolverGroupReducer,
  attachmentState: attachmentReducer,
  ticketingSuggestionModalState: ticketingSuggestionModalReducer
});

export default rootReducer;



// WEBPACK FOOTER //
// ./app/main/rootReducer.js